// Short-url
import {getChestApiUrl} from "../../helpers";
const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };

export default (url)=> {
    return new Promise((resolve, reject) => {
        return fetch(`${getChestApiUrl()}/chestApi/short-url`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ url })
        })
            .then(r => r.json())
            .then(res => {
                if (!res.error) return resolve(res.shortUrl);
                return reject(res.error);
            })
            .catch(err => {
                reject(err)
            });
    });
}